const controllers = {
  home: require('./views/home'),
  testing: require('./views/testing'),
  view_scholarships: require('./views/view-scholarships'),
  editUser: require('./views/edit-user'),
  list_scholarships: require('./views/list-scholarships'),
  dashboard: require('./views/dashboard'),
}

export default controllers
